import { inject, injectable } from "inversify";
import IChatService from "./IChatService";
import { PersonApi } from "../api/PersonApi";
import { DiTokens } from "../diTokens";
import IAlertService from "../alert/IAlertService";
import IErrorService from "../error/IErrorService";
import { ChatMeassagesData } from "../../data/chatMeassagesData";

@injectable()
/**Сервис настроек веб клиента */
export default class ChatService implements IChatService {
  constructor(
    @inject(DiTokens.AlertService) private alertService: IAlertService,
    @inject(DiTokens.ErrorService) private errorService: IErrorService
  ) {}

  public async getChatMessages(): Promise<Array<ChatMeassagesData>> {
    try {
      const messages: Array<ChatMeassagesData> = await PersonApi.getEFrontChatMessages();
      return messages;
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, "");
      return null;
    }
  }

  public async sendChatMessage(message: string): Promise<Array<ChatMeassagesData>> {
    try {
      const messages: Array<ChatMeassagesData> = await PersonApi.sendChatMessage(message);
      return messages
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, "");
      return null;
    }
  }

  
}
